import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

import * as ResourceApi from 'api/resources';
import ResourceFormProxy from 'classes/ResourceFormProxy';
import {createResourceAction} from "../resources/actions";
import {extractResourceIdsWithPath, isFunction} from "../utils/DBUtils";

const CreateButtonSection = (props) => (
    <section className="create-button-section">
        {props.creatableTypes.map((type, i) => (
          <Fragment key={i}>
            {props.canCreate && (
                <Button key={`createButton-${i}`} onClick={() => props.createResource(
                      type,
                      props.formProxy.baseResource["MASTER"],
                      props.formProxy.currentBaseResource,
                      props.formProxy.resourcePath,
                      props.formProxy.fieldPath,
                      (isFunction(props.additionalArgs) ? props.additionalArgs(props.formProxy) : props.additionalArgs)
                  )}>
                  <Icon name="plus"/> <FormattedMessage id={'create.button.' + type.toLowerCase()} defaultMessage={type}/>
                </Button>
            )}
          </Fragment>
        ))}
    </section>
);

CreateButtonSection.propTypes = {
    formProxy: PropTypes.instanceOf(ResourceFormProxy),
    creatableTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(ResourceApi.Types))),
    additionalArgs: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    // console.log(`state`, state)
    const canCreate = !ownProps.field.canCreate || ownProps.field.canCreate(ownProps.formProxy);
    return {canCreate};
};

const mapDispatchToProps = (dispatch, ownProps, ...rest) => {

    // console.log(`ownProps`, ownProps)
    // console.log(`ownProps.formProxy.resource`, ownProps.formProxy.resource)
    // console.log(`ownProps.formProxy.currentResource`, ownProps.formProxy.currentResource)
    // console.log(`ownProps.formProxy.currentBaseResource`, ownProps.formProxy.currentBaseResource)
    // console.log(`rest`, rest)
    
    return ({

        createResource: (type, masterResource, rootResource, resourcePath, fieldPath, additionalArgs) => dispatch(createResourceAction(
            type,
            {   numToCreate: 1, 
                fieldName: ownProps.field.name,
                ...additionalArgs
            },
            rootResource,
            extractResourceIdsWithPath(masterResource, rootResource, resourcePath),
            resourcePath,
            fieldPath
        ))
    })
};

const ConnectedCreateButtonSection = connect(mapStateToProps, mapDispatchToProps)(CreateButtonSection);

export const createButtonSectionFactory = (...creatableTypes) => {
        return (props) => (
            <ConnectedCreateButtonSection creatableTypes={creatableTypes} {...props}/>
        );    
};

export const createButtonSectionFactoryWithAdditionalArgs = (additionalArgs, ...creatableTypes) => {
    return (props) => {
        console.log(`props`, props)  
        return (
        <ConnectedCreateButtonSection additionalArgs={additionalArgs} creatableTypes={creatableTypes} {...props}/>
    )};
};



// WEBPACK FOOTER //
// ./public/hoc/CreateButtonSection.jsx